import React, { memo } from 'react';
import { func, bool, string } from 'prop-types';
import Radium from 'radium';
import { UTButton, UTLabel } from '@widergy/energy-ui';

import UTForm from 'app/components/UTForm';
import { message } from 'utils/stringUtils';
import { appConfig } from 'config/customization';

import stylesJS from './styles';
import styles from './styles.module.scss';
import { PUBLIC_IDENTITY_FIELDS } from './constants';

const PublicAuthForm = ({ handleSubmit, description, onGoToHome, submitFailed, invalid }) => (
  <form onSubmit={handleSubmit} style={stylesJS.container} noValidate>
    <UTLabel black className={styles.description}>
      {description}
    </UTLabel>
    <UTForm fields={PUBLIC_IDENTITY_FIELDS} />
    <div style={styles.buttonsContainer}>
      {appConfig.balanceAndLastBillQuery.showCancelButton && (
        <UTButton secondary onPress={onGoToHome} style={{ ...stylesJS.button, ...stylesJS.cancel }}>
          {message('Commons:cancel')}
        </UTButton>
      )}
      <UTButton disabled={submitFailed && invalid} style={stylesJS.button} type="submit">
        {message('PublicLastBill:query')}
      </UTButton>
    </div>
  </form>
);

PublicAuthForm.propTypes = {
  description: string,
  handleSubmit: func.isRequired,
  onGoToHome: func.isRequired,
  invalid: bool,
  submitFailed: bool
};

export default memo(Radium(PublicAuthForm));
